
import React from 'react';
import { Link } from 'react-router-dom';
import { User, BookOpen, Award } from 'lucide-react';
import { handleScrollReset } from '@/utils/navigationUtils';

interface UserNavigationProps {
  isUserDashboard: boolean;
  getDashboardLink: () => string;
}

const UserNavigation: React.FC<UserNavigationProps> = ({
  isUserDashboard,
  getDashboardLink,
}) => {
  return (
    <div className="flex items-center space-x-4">
      <Link to={getDashboardLink()} className="text-white hover:text-gray-200 flex items-center" onClick={handleScrollReset}>
        <User className="h-4 w-4 mr-1" />
        Dashboard
      </Link>
      {isUserDashboard && (
        <>
          <Link to="/user/profile" className="text-white hover:text-gray-200 flex items-center" onClick={handleScrollReset}>
            <User className="h-4 w-4 mr-1" />
            Profile
          </Link>
          <Link to="/user/payout-report" className="text-white hover:text-gray-200 flex items-center" onClick={handleScrollReset}>
            <BookOpen className="h-4 w-4 mr-1" />
            Payout Report
          </Link>
          <Link to="/user/referral-tracking" className="text-white hover:text-gray-200 flex items-center" onClick={handleScrollReset}>
            <BookOpen className="h-4 w-4 mr-1" />
            Referral Tracking
          </Link>
          <Link to="/user/points-redemption" className="text-white hover:text-gray-200 flex items-center" onClick={handleScrollReset}>
            <Award className="h-4 w-4 mr-1" />
            Points Redemption
          </Link>
        </>
      )}
    </div>
  );
};

export default UserNavigation;
